export default __webpack_public_path__ + "static/media/books-02.05578245.jpg";